/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const CommunityLibraryPermissionsParser = 
/* #__PURE__ */ parsers.object([
    ['view', /* #__PURE__ */ parsers.exactly('any', 'none', 'public')],
    [
        'delete',
        /* #__PURE__ */ parsers.exactly('any', 'none', 'own', 'public', 'tenant'),
    ],
]);
export class CommunityLibraryPermissions extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CommunityLibraryPermissionsParser.decode(input).map(res => new CommunityLibraryPermissions(res));
    }
    static unsafeDecode(input) {
        return CommunityLibraryPermissions.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CommunityLibraryPermissionsParser.encode(data);
    }
    static schema() {
        return CommunityLibraryPermissionsParser.schema();
    }
}
